// Disable dakaaseffect (multi-seasnal-effect Shopify app) cursor follower
// AND snow particle effect on white-label club store pages. Loaded
// conditionally by theme.liquid for template.suffix == 'tbarc' or 'wvarc'.
//
// Timing: this file loads with `defer`, earlier in document order than the
// app's own cursor-effect.js / effect-home.js. Deferred scripts run in
// document order after HTML parsing, so window.dakaaseffect is already set
// by the app's inline config when this runs. We blank cursor.type and
// snow.type before the app's switches read them. Both init paths are
// gated on a non-empty `type` (the cursor switch has no default case;
// the snow init is wrapped in `if (snow && snow.type)`).
if (window.dakaaseffect) {
  window.dakaaseffect.cursor = { type: '', isMobile: false, cursortext: '' };
  window.dakaaseffect.snow = { type: '', snowOpt: {} };
}

// Backstop: if the pre-empt ever fails (e.g. the app drops `defer` from
// its scripts), the effect DOM nodes have stable ids we can remove.
// DOMContentLoaded fires after deferred scripts complete — nodes are in
// DOM by then. Removing them stops the visual effect; any rAF loops keep
// drawing to detached canvases (negligible CPU).
document.addEventListener('DOMContentLoaded', function () {
  ['dakaas-cursor-effect', 'dakaas-effect', 'dakaas-container', 'dakaas-style', 'dakaasmark'].forEach(function (id) {
    var node = document.getElementById(id);
    if (node) node.remove();
  });
});
